var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "indicator-style-icon", style: _vm.iconStyle },
    [
      _c("i", {
        class:
          _vm.chartData.styleConfig.helperData.indicatorRowIconMap[_vm.rowKey],
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }